export default "__VITE_ASSET__QQGUdDhD__"